import React, {useEffect, useState} from 'react'
import { Formik, Field, Form, FieldArray } from 'formik';
import { getImages } from '../const';

export const FeaturedVehileAccordionItem = ({  getVehicleData, vehicleData, priceFormatter, inventoryManage }) => {
      
    useEffect(() => {
        getVehicleData();
    },[]);

    const [inventoryManageData,setInventoryManageData] = useState({});

    useEffect(() => {
        if(vehicleData) {
            const inventory_manage_data = vehicleData.reduce((acc, item) => {
                acc[item.vin] = item.inventory_manage; // Or acc[key] = item; if you want the whole item
                return acc;
            }, {});
            console.log(inventory_manage_data);
            setInventoryManageData(inventory_manage_data);
        }
    },[vehicleData]);

    const updateInventoryManage = (e,vin,field,checkbox=false) => {

        setInventoryManageData((prev) => ({
            ...prev,
            [vin] : {...prev[vin],[field]:checkbox ? e.target.checked : e.target.value}
        }));

        inventoryManage({...inventoryManageData[vin],[field]:checkbox ? e.target.checked : e.target.value,["vin"]:vin})
    }

    return (
        <>
            <div className='d-flex align-items-center justify-content-between'>
                <div className='sm-title'>Select up to 6 vehicles <img className='ms-2' src={getImages('info-icon1.png')}/></div>
                <div className='xs-title font-14'>{Object.values(inventoryManageData).filter(item => item.lease_special).length} of 6 Selected</div>
            </div>
            <div className="accordion ue-accordion featured-accordion" id="accordionExample">
                <table className='w-100 custom-table'>
                    <thead>
                        <tr>
                            <th style={{ width: '32%' }}>Vehicle</th>
                            <th style={{ width: '16%' }} className='text-center'>Price</th>
                            <th style={{ width: '16%' }} className='text-center'>Miles</th>
                            <th style={{ width: '16%' }} className='text-center'>Stock #</th>
                            <th style={{ width: '20%' }} className='text-end'>&nbsp;</th>
                        </tr>
                    </thead>
                </table>
                {vehicleData && vehicleData.map((item, index) => {
                    const isSelected = item.inventory_manage.featured ? 'featured' : '';
                    // console.log("item.id", item.id)
                    return (
                        <div className={`accordion-item ${isSelected}`} key={index}>
                            <table className='w-100 custom-table'>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '32%' }} className='text-start'>
                                            <div className='xs-title text-blue'>{item.vehicle_name}</div>
                                        </td>
                                        <td style={{ width: '16%' }} className='text-center'><div className='xs-title'>{priceFormatter(item.price,true)}</div></td>
                                        <td style={{ width: '16%' }} className='text-center'>{priceFormatter(item.mileage)}</td>
                                        <td style={{ width: '16%' }} className='text-center'>{item.stockno}</td>
                                        <td style={{ width: '20%' }} className='text-end pe-4'>
                                            <div className='d-flex'>
                                                {inventoryManageData && item.vin in inventoryManageData && <div className="custom-checkbox dash-checkbox ms-auto me-2">
                                                    <input
                                                        type='checkbox'
                                                        id={`chk_${item.vin}`}
                                                        checked={inventoryManageData[item.vin].featured}
                                                        onChange={(e) => {updateInventoryManage(e,item.vin,'featured',true)}}
                                                    />
                                                    <label htmlFor={`chk_${item.vin}`} className="w-100"></label>
                                                </div>}
                                                <div>
                                                    <button type='button' className='btn-menu-icon text-uppercase'>
                                                        <img src={getImages('menu-icon.png')}/>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                })}
            </div>
        </>
    )
}
